import { Button, Flex, Modal } from 'antd'
import { useCallback, useContext, useMemo } from 'react'
import { InvoiceSummaryWithCustomerJobData } from '../../../domain/invoicing/invoice'
import InvoiceDetails from './InvoiceDetails'
import InvoiceDetailStatusBar from './InvoiceDetailStatusBar'
import JobInvoicingContext, { ActiveInvoicingModal, JobInvoicingContextData } from '../JobInvoicingContext'
import InvoiceActionsContext from '../AllInvoices/InvoiceActionsContext'
import { useCustomerEmailsQuery } from '../../../domain/customers/customerQueries'

type Props = {
  invoiceSummary: InvoiceSummaryWithCustomerJobData | null
  onClose: () => void
}

const InvoiceDetailModal = ({ invoiceSummary, onClose }: Props) => {
  const { openModal } = useContext(InvoiceActionsContext)
  const customerEmailsQuery = useCustomerEmailsQuery(invoiceSummary?.customerId ?? 0)
  const customerEmails = useMemo(
    () => customerEmailsQuery.data ?? [],
    [customerEmailsQuery.data]
  )

  const setActiveInvoicingModal = useCallback((modal: ActiveInvoicingModal | null) => {
    if (!modal || !invoiceSummary) {
      return
    }
    openModal(modal.modal, invoiceSummary)
  }, [invoiceSummary, openModal])
  const jobInvoicingBridge = useMemo<JobInvoicingContextData>(() => ({
    activeInvoicingModal: null,
    setActiveInvoicingModal,
    customerEmails
  }), [setActiveInvoicingModal, customerEmails])

  return (
    <JobInvoicingContext.Provider value={jobInvoicingBridge}>
      <Modal
        open={!!invoiceSummary}
        title={invoiceSummary
          ? <Flex justify="space-between" align="center" style={{ marginRight: 24 }}>
              <span>{invoiceSummary.customerDisplayName} — {invoiceSummary.jobName}</span>
              <span>Invoice #{invoiceSummary.invoiceNumber}</span>
            </Flex>
          : ''
        }
        onCancel={onClose}
        footer={<Flex justify="flex-end"><Button onClick={onClose}>Close</Button></Flex>}
        width={800}
        destroyOnClose
      >
        {invoiceSummary && <>
          <InvoiceDetailStatusBar invoiceSummary={invoiceSummary} />
          <InvoiceDetails
            invoiceSummary={invoiceSummary}
            preventExports={!invoiceSummary.customerQboId}
          />
        </>}
      </Modal>
    </JobInvoicingContext.Provider>
  )
}

export default InvoiceDetailModal
